/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailureStatusRuleVm
 */
export interface FailureStatusRuleVm {
    /**
     * 
     * @type {string}
     * @memberof FailureStatusRuleVm
     */
    fromId?: string;
    /**
     * 
     * @type {string}
     * @memberof FailureStatusRuleVm
     */
    toId?: string;
}

export function FailureStatusRuleVmFromJSON(json: any): FailureStatusRuleVm {
    return FailureStatusRuleVmFromJSONTyped(json, false);
}

export function FailureStatusRuleVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureStatusRuleVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromId': !exists(json, 'fromId') ? undefined : json['fromId'],
        'toId': !exists(json, 'toId') ? undefined : json['toId'],
    };
}

export function FailureStatusRuleVmToJSON(value?: FailureStatusRuleVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromId': value.fromId,
        'toId': value.toId,
    };
}


